/**
 * Zzzing Land Owner API
 * Zzzing Land Owner API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PropertyShortRef { 
    id?: string;
    friendly_reference?: string;
    name?: string;
    address?: string;
    building_name?: string;
    /**
     * A friendly reference provided by the landowners to identify the property for themselves
     */
    owner_property_reference?: string;
}

